import { createSlice } from '@reduxjs/toolkit';

export const socialproof = createSlice({
  name: 'socialproof',
  initialState: {
    socialproofcampaigns: [],
    proofcampaignId:'',
    proofpixelid: '',
    proofpixeldata: [],
    socialproofcampaign:{},
    proofgoals:[],
    proofdisplayurls:[],
    oneproofgoal:{},
    proofnotifications:[]
  },
  reducers: {
    setSocialProofCampaignReducer: (state, action) => {
      state.socialproofcampaigns = action?.payload;
    },
    addSocialProofCampaignReducer: (state, action) => {
       state.socialproofcampaign={...action?.payload};
       state.proofcampaignId=action?.payload._id;
       state.socialproofcampaigns = [...state.socialproofcampaigns, action.payload];
      },
    setSocialOneProofCampaignReducer:(state, action) =>{
        state.proofcampaignId=action.payload._id;
        state.socialproofcampaign={...action?.payload};
    },
    setProofGoalReducer: (state, action) => {
        state.proofgoals = [...action.payload];
    },
    addProofGoalReducer: (state, action) => {
        state.proofgoals = [...state.proofgoals, action.payload];
    },
    setSocialOneProofGoalReducer: (state, action) => {
        state.oneproofgoal = {...action.payload};
      },
    addSocialDisplayUrlReducer:(state, action) =>{
      state.proofdisplayurls = [...state.proofdisplayurls, action.payload];
    },
    setSocialDisplayUrlReducer:(state, action) =>{
      state.proofdisplayurls = [...action.payload];
    },
    setProofPixelReducer: (state, action) => {
      state.proofcampaignId = action?.payload._id;
    },
    setPixelDataReducer: (state, action) => {
      state.proofpixeldata = [...action?.payload]
    }
  }
});

export const {
    setSocialProofCampaignReducer,
    addSocialProofCampaignReducer,
    setSocialOneProofCampaignReducer,
    setProofGoalReducer,
    addProofGoalReducer,
    setSocialOneProofGoalReducer,
    addSocialDisplayUrlReducer,
    setSocialDisplayUrlReducer,
    setProofPixelReducer,
    setPixelDataReducer,
} = socialproof.actions;

export default socialproof.reducer;
